// src/components/Register.js
import React, { useState } from 'react';
import { createStudentAccount } from '../services/authService';

const Register = ({ onRegistrationSuccess, switchToLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    phoneNumber: '',
    name: ''
  });
  
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Form validation
    if (!formData.email || !formData.password || !formData.confirmPassword || !formData.phoneNumber || !formData.name) {
      setError('Please fill in all fields');
      return;
    }
    
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    // Phone number validation - basic format check
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(formData.phoneNumber)) {
      setError('Please enter a valid 10-digit phone number without spaces or dashes');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const result = await createStudentAccount(
        formData.email,
        formData.password,
        formData.phoneNumber,
        formData.name
      );
      
      if (result.success) {
        onRegistrationSuccess(result.user);
      } else {
        setError(result.error || 'Registration failed');
      }
    } catch (err) {
      setError(err.message || 'An error occurred during registration');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="login-card">
      <div className="login-header">
        <div className="logo-container">
          📷
        </div>
        <h2>Create Student Account</h2>
        <p>Sign up to start booking equipment</p>
      </div>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="your.email@example.com"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number</label>
          <input
            id="phoneNumber"
            name="phoneNumber"
            placeholder="10-digit phone number"
            value={formData.phoneNumber}
            onChange={handleChange}
            type="tel"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="name">Full Name</label>
          <input
            id="name"
            name="name"
            placeholder="Your full name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            name="password"
            type="password"
            placeholder="Minimum 6 characters"
            value={formData.password}
            onChange={handleChange}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password</label>
          <input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            placeholder="Re-enter your password"
            value={formData.confirmPassword}
            onChange={handleChange}
          />
        </div>
        
        {error && <p className="error-message">{error}</p>}
        
        <button className="login-button animate-fade-in ripple-effect" type="submit" disabled={loading}>
          {loading ? 'Registering...' : 'Register'}
        </button>
        
        <div className="auth-link" style={{ textAlign: 'center', marginTop: '1rem' }}>
          <p>
            Already have an account?{' '}
            <button 
              type="button" 
              onClick={switchToLogin}
              style={{ 
                background: 'none', 
                border: 'none', 
                color: 'var(--accent-color)', 
                cursor: 'pointer',
                padding: 0,
                textDecoration: 'underline'
              }}
            >
              Log in
            </button>
          </p>
        </div>
      </form>
    </div>
  );
};

export default Register;
